module.exports = __webpack_public_path__ + "img/card-frame-gray.f3e7d8bc.png";